import Vue from 'vue'
const moment = require('moment')
require('moment/locale/es')

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  const val = value.toString()
  return `${val[0].toUpperCase()}${val.substr(1)}`
})

Vue.filter('lowercase', function (value) {
  if (!value) return ''
  return value.toString().toLowerCase()
})

Vue.filter('fecha_splitter', function (value) {
  let data = value.split(' ')
  const fecha = moment(data[0], 'YYYY-MM-DD').format('D MMM')
  return `${fecha} a las ${data[1].substr(0,5)}`
})

Vue.filter('phone_format', function (value) {
  if (!value) return '---'
  const v = value.split('')
  const a = v[0] + v[1]
  const b = v[2]
  const c = v[3] + v[4] + v[5] + v[6]
  const d = v[7] + v[8] + v[9] + v[10]
  return `+(${a}) ${b} ${c} ${d}`
})

Vue.filter('phone_format_short', function (value) {
  if (!value) return '---'
  const v = value.split('')
  const a = v[0]
  const b = v[1] + v[2] + [3] + v[4]
  const c = v[5] + v[6] + v[7] + v[8]
  return `+(56) ${a} ${b} ${c}`
})

Vue.filter('money', function (value) {
  return Number(value).toLocaleString('es')
})

Vue.filter('number', function (value) {
  return value.toString()
      .replace(/\./g, '')
      .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
})

Vue.filter('rut', function (value) {
  if (!value) return ''
  if(value.length === 1) return value

  var clean = value.replace(/\./g, '')
      .replace(/\-/g, '')

  if(clean.length > 9) clean = clean.substring(0, 9)

  const firstSection = clean.substring(0, clean.length-1).toString()
      .replace(/\./g, '')
      .replace(/\B(?=(\d{3})+(?!\d))/g, ".")

  const dv = clean.substring(clean.length-1, clean.length)

  return `${firstSection}-${dv.toUpperCase()}`
})

Vue.filter('humanDate', function(value){
  const moment = require('moment')
  return moment(value).calendar(null,{
    lastDay : '[Ayer]',
    sameDay : '[Hoy]',
    nextDay : '[Mañana]',
    lastWeek : '[Pasado] dddd DD',
    nextWeek : '[Próximo] dddd DD',
    sameElse : 'DD-MM-YYYY'
  })
})
